import { render, staticRenderFns } from "./AsociarMensajesForm2.vue?vue&type=template&id=bc779d7c&scoped=true&"
import script from "./AsociarMensajesForm2.vue?vue&type=script&lang=ts&"
export * from "./AsociarMensajesForm2.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarMensajesForm2.vue?vue&type=style&index=0&id=bc779d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc779d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bc779d7c', component.options)
    } else {
      api.reload('bc779d7c', component.options)
    }
    module.hot.accept("./AsociarMensajesForm2.vue?vue&type=template&id=bc779d7c&scoped=true&", function () {
      api.rerender('bc779d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/AsociarMensajesForm2.vue"
export default component.exports